<bw-modal-legacy modalWidth="medium">
  <typography-legacy title-medium>{{model.title}}</typography-legacy>
  <typography-legacy *ngFor="let text of model.bodyText" class="body mb-md" text-large-regular color="var(--secondary-text)">
    {{text}}
  </typography-legacy>
  <div class="footer flex-row row-reverse">
      <button bw-button-legacy (click)="primaryCtaClick($event);">
        <typography-legacy text-large-semibold>{{model.primaryCta}}</typography-legacy></button>
      <button bw-link-button-legacy class="mr-xs" (click)="secondaryCtaClick($event)" *ngIf="model.secondaryCta">{{model.secondaryCta}}</button>
  </div>
</bw-modal-legacy>
